import LanguagesContext from "context/language/LanguagesContext";
import ThemeContext from "context/theme/ThemeContext";
import { MessagesProvider } from "context/messages/MessagesContext";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PublicViewsLayout from "views/public/PublicViewsLayout";

const App = () => {
    return (
        <div className="App">
            <Router>
                <LanguagesContext>
                    <ThemeContext>
                        <MessagesProvider>
                            <Routes>
                                <Route path="/*" element={<PublicViewsLayout />} />
                            </Routes>
                        </MessagesProvider>
                    </ThemeContext>
                </LanguagesContext>
            </Router>
        </div>
    );
};

export default App;
